import { GlobalStylesProps, GlobalStyles as MUIGlobalStyles } from '@mui/material';
import { FC } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const sharedStyles: GlobalStylesProps['styles'] = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  overscrollBehavior: 'none',
  scrollBehavior: 'smooth',
  WebkitOverflowScrolling: 'touch',
};

export const GlobalStyles: FC = () => (
  <MUIGlobalStyles
    styles={{
      html: sharedStyles,
      body: sharedStyles,
      main: sharedStyles,
    }}
  />
);
